import API from "../libs/api";

const BASE_PATH = "/api/admin/teacher-attendance/teacher";

function buildSalaryQuery({ schoolId, academicYearId, month }) {
  const params = new URLSearchParams({
    schoolId: String(schoolId),
    academicYearId: String(academicYearId),
    month,
  });

  return params.toString();
}

function buildReportQuery({ schoolId, academicYearId, month }) {
  const params = new URLSearchParams({
    academicYearId: String(academicYearId),
  });

  if (schoolId !== undefined && schoolId !== null && schoolId !== "") {
    params.set("schoolId", String(schoolId));
  }

  if (month) {
    params.set("month", month);
  }

  return params.toString();
}

const TeacherSalaryService = {
  calculate: ({ teacherId, ...params }) =>
    API.get(
      `${BASE_PATH}/${encodeURIComponent(teacherId)}/salary?${buildSalaryQuery(params)}`
    ),

  pay: ({ teacherId, ...params }) =>
    API.post(
      `${BASE_PATH}/${encodeURIComponent(teacherId)}/pay-salary?${buildSalaryQuery(params)}`,
      {}
    ),

  getTeacherHistory: ({ teacherId, schoolId, academicYearId, month }) =>
    API.get(
      `${BASE_PATH}/${encodeURIComponent(teacherId)}/salary-history?${buildReportQuery({
        schoolId,
        academicYearId,
        month,
      })}`
    ),

  getSchoolReport: ({ schoolId, academicYearId, month }) =>
    API.get(
      `/api/admin/teacher-attendance/school/${encodeURIComponent(schoolId)}/salary-report?${buildReportQuery({
        academicYearId,
        month,
      })}`
    ),
};

export default TeacherSalaryService;
